/**
 * Download-data template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import DynamicSlider from './dynamic-carousel';
import 'keen-slider/keen-slider.min.css'

require('./lib/GSAP');
// import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

// gsap.registerPlugin(ScrollTrigger);

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Download-data';
const datasetList = document.querySelector('.download-data-datasets__nav__list');
const datasetListItems = document.querySelectorAll('.download-data-datasets__nav__list-item');
const datasetCards = document.querySelectorAll('.download-data-dataset');
const twirldown = document.querySelector('.download-data-datasets__nav__more');
const mobileCurrent = document.querySelector('.download-data-datasets__nav__mobile-current');
let currentTitle = datasetListItems[0].firstElementChild.getAttribute('title');
let current;

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const onTwirldown = () => {
  twirldown.classList.toggle('open');
  datasetList.classList.toggle('show');
}

const onListItem = () => {
  twirldown.classList.remove('open');
  datasetList.classList.remove('show');
}

const setCurrentTitle = () => {
  current = document.querySelector('.download-data-datasets__nav__list-item.current');
  currentTitle = current ? current.firstElementChild.getAttribute('title') : currentTitle;
  mobileCurrent.textContent = currentTitle;
}

datasetListItems.forEach(el => el.addEventListener('click', onListItem));
twirldown.addEventListener('pointerup', onTwirldown);

datasetCards.forEach((el, i) => {
  ScrollTrigger.create({
    trigger: el,
    toggleClass: {
      targets: datasetListItems[i],
      className: 'current',
    },
    onToggle: setCurrentTitle,
    start: i == 0 ? 'top bottom': 'top top+=25%',
    end: 'bottom top+=21%',
  });
});

// gsap.to('#svg-circle-text', {
//   rotate: 180,
//   duration: 2,
//   transformOrigin: 'center center',
//   scrollTrigger: {
//     trigger: 'body',
//     scrub: true,
//     start: 'top top',
//     end: 'bottom bottom',
//   }
// })

// Bootstrap global functionality
Global();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
